import type { BoatPlace, Boat } from '../lib/boats';
import BoatPlaceCard from './BoatPlaceCard';

interface Props {
  places: BoatPlace[];
  boats: (Boat & { id: string })[];
}

export default function BoatPlaceList({ places, boats }: Props) {
  return (
    <div>
      {places
        .slice()
        .sort((a, b) => Number(a.number) - Number(b.number))
        .map((place) => (
          <BoatPlaceCard
            key={place.id}
            place={place}
            boats={boats.filter((b) => b.boatPlaceId === place.id)}
          />
        ))}
    </div>
  );
}
